module.exports = __webpack_public_path__ + "static/fonts/ionicons.24712f6.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/styles/common/iconfont/fonts/ionicons.ttf
// module id = 67
// module chunks = 10